function locationReplace(url) {
  window.location.replace(url);
}

export default locationReplace;
